// brand.md: calm, never shaming. Weight goes up and down; the copy never judges a direction.

export const copy = {
  moduleName: 'Weight',
  navLabel: 'Weight',
  loading: 'Loading…',
  empty: 'Log your first weigh-in. One a day is plenty; the 7-day average smooths the swings.',
  logWeight: 'Log weight',
  editWeight: 'Edit weight',
  logTitle: 'Log your weight',
  editTitle: (day: string) => `Weight for ${day}`,
  weight: 'Weight',
  date: 'Date',
  note: 'Note (optional)',
  notePlaceholder: 'After the gym, new scale…',
  save: 'Save',
  delete: 'Delete',
  replaceHint: 'This day already has a weigh-in. Saving replaces it.',
  logged: (w: string) => `Logged ${w}.`,
  updated: (w: string) => `Updated to ${w}.`,
  deleted: 'Weigh-in deleted.',
  undo: 'Undo',
  today: 'Today',
  latest: 'Latest',
  average7: '7-day average',
  avgChange: (change: string) => `${change} from the week before`,
  weeklyRate: 'Weekly rate',
  ratePerWeek: (change: string) => `${change} a week`,
  rateSteady: 'Steady',
  rateNotYet: 'Shows after a week of weigh-ins',
  trend: 'Trend',
  trendLabel: (n: number, avg: string | null) =>
    `${n === 1 ? '1 weigh-in' : `${n} weigh-ins`} on the chart${avg ? `, 7-day average ${avg}` : ''}.`,
  legendDaily: 'Daily weigh-ins',
  legendAverage: '7-day average',
  legendGoal: 'Goal',
  noTrend: 'The trend line starts with your first weigh-in.',
  recent: 'Recent weigh-ins',
  goal: 'Goal',
  setGoal: 'Set a goal',
  editGoal: 'Edit goal',
  goalOptional:
    'A goal is optional. Progress uses your 7-day average, so one heavy morning won’t move it.',
  goalWeight: 'Goal weight',
  saveGoal: 'Save goal',
  removeGoal: 'Remove goal',
  goalRemoved: 'Goal removed.',
  goalSaved: 'Goal saved.',
  goalNeedsWeight: 'Log a weigh-in first, so progress has a starting point.',
  goalFrom: (start: string, goal: string) => `From ${start} to ${goal}`,
  goalToGo: (left: string) => `${left} to go`,
  goalReached: 'You reached your goal. Nice work.',
  goalPercent: (pct: number) => `${pct}% of the way`,
  noGoal: 'No goal set. Tracking the trend is enough on its own.',
  unit: 'Unit',
  unitHint: 'Every weight shows in this unit. Entries keep the unit they were typed in.',
  enteredAs: (w: string) => `Entered as ${w}`,
} as const;

export function errorText(error: string): string {
  switch (error) {
    case 'empty':
      return 'Enter your weight.';
    case 'not_a_number':
      return 'Use numbers only, like 72.4.';
    case 'out_of_range':
    case 'bad_weight':
      return 'That weight looks off. Check the number and the unit.';
    case 'future_date':
      return 'Pick today or an earlier day.';
    case 'bad_date':
      return 'Pick a real day.';
    case 'same_as_now':
      return 'Pick a goal different from your current weight.';
    case 'not_found':
      return 'That weigh-in is gone already.';
    default:
      return 'Something went wrong. Try again.';
  }
}
